document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('.universe-item');
  const linkToSectionMap = {
    0: 'landing-mujer',
    1: 'landing-hombre',
    2: 'landing-licencias',
    3: 'landing-mujer',
    4: 'landing-hombre',
    5: 'landing-licencias',
  };
  const sectionToMenuMap = {
    'landing-mujer': 'menu-mujer',
    'landing-hombre': 'menu-hombre',
    'landing-licencias': 'menu-licencias',
  };
  const sidebar = document.body;
  const menuRoot = document.getElementById('menu-mujer');
  const parentLinks = document.querySelectorAll('.universe-item');

  if (!menuRoot|| parentLinks.length === 0) {
    console.log('Menu.js: Expected DOM structure not found, skipping initialization');
    return;
  }


  const sectionIds = new Set(Object.values(linkToSectionMap));
  const menuIds = new Set(Object.values(sectionToMenuMap));

  function resolveTargetSectionId(link, index) {
    if (linkToSectionMap[index] !== undefined) {
      return linkToSectionMap[index];
    }
    const text = (link.textContent || '').trim().toLowerCase();
    if (text.includes('mujer')) return 'landing-mujer';
    if (text.includes('hombre')) return 'landing-hombre';
    if (text.includes('licen')) return 'landing-licencias';
    return 'landing-mujer';
  }

  function showOnlySection(idToShow) {
    sectionIds.forEach(sectionId => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.style.display = (sectionId === idToShow) ? 'inherit' : 'none';
      }
    });

    menuIds.forEach(menuId => {
      const menu = document.getElementById(menuId);
      if (menu) {
        const shouldShow = sectionToMenuMap[idToShow] === menuId;
        menu.classList.toggle('hidden', !shouldShow);
        menu.style.display = shouldShow ? '' : 'none';
      }
    });
  }

  showOnlySection('landing-mujer');
  parentLinks.forEach((link, index) => {
    link.addEventListener('click', function (e) {
      const targetSectionId = resolveTargetSectionId(this, index);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.removeAttribute('href');

      links.forEach(el => el.classList.remove('is-active'));
      this.classList.add('is-active');
      showOnlySection(targetSectionId);

      const header = document.querySelector('[class*="header-"][class*="submenu-open"]');
      if (header) {
        const allSubmenus = document.querySelectorAll('[class*="header-mobile-submenu-"]');
        const activeIndex = Array.from(allSubmenus).findIndex(
          submenu => submenu.style.display === 'block'
        );

        if (activeIndex !== -1) {
          const closeSubmenu = window.closeSubmenu || function(index) {
            const submenu = allSubmenus[index];

            const menuIconClass = submenu.className.match(/header-mobile-submenu-([^\s]+)/);
            const menuIcon = menuIconClass ? 
              document.querySelector(`.header-menu-link-open-${menuIconClass[1]}`) : 
              null;

            if (menuIcon) menuIcon.classList.remove('active');

            submenu.style.transition = 'all 0.25s ease 0s';
            submenu.style.height = '0';
            submenu.style.opacity = '0';

            setTimeout(() => {
              submenu.style.display = 'none';
              submenu.classList.add('hidden');

              document.querySelectorAll('[class*="header-sidebar-menu-list-"]').forEach(menu => {
                Array.from(menu.children).filter(child => child.tagName === 'LI').forEach(item => {
                  item.style.display = '';
                });
              });

              header.classList.remove('submenu-open');
            }, 300);
          };

          closeSubmenu(activeIndex);
        }
      }

      return false;
    });
  });
});
